import React, { useEffect, useState } from 'react';
import Navbar from '../../components/Navbar';
import API from '../../utils/api';
import toast from 'react-hot-toast';
import { useAuth } from '../../context/AuthContext';

export default function AdminSettings() {
  const [form, setForm] = useState({
    brand_name:'', tagline:'', upi_id:'', payment_link:'',
    contact_email:'', contact_phone:'', contact_whatsapp:'',
    contact_address:'', contact_city:'', contact_hours:'', contact_about:'',
    razorpay_key_id:'',
    razorpay_key_secret:'',
    gemini_api_key:'',
    gemini_model:'',
    blocked_junk_names:'',
    blocked_profanity_words:''
  });
  const [logo, setLogo] = useState(null);
  const [upiQr, setUpiQr] = useState(null);
  const [currentQr, setCurrentQr] = useState('');
  const [banner, setBanner] = useState(null);
  const [bannerLink, setBannerLink] = useState('');
  const [banners, setBanners] = useState([]);
  const [saving, setSaving] = useState(false);
  const { loadSettings } = useAuth();

  const parseList = raw => {
    try {
      const arr = JSON.parse(raw || '[]');
      return Array.isArray(arr) ? arr.join('\n') : '';
    } catch { return ''; }
  };

  useEffect(() => {
    API.get('/admin/settings').then(r => {
      setForm({
        brand_name: r.data.brand_name||'',
        tagline: r.data.tagline||'',
        upi_id: r.data.upi_id||'',
        payment_link: r.data.payment_link||'',
        contact_email: r.data.contact_email||'support@oexams.com',
        contact_phone: r.data.contact_phone||'',
        contact_whatsapp: r.data.contact_whatsapp||'',
        contact_address: r.data.contact_address||'',
        contact_city: r.data.contact_city||'India',
        contact_hours: r.data.contact_hours||'Mon–Sat, 9 AM – 6 PM IST',
        contact_about: r.data.contact_about||'OExams is an online examination platform built for Indian educators. We help teachers and schools create, manage, and analyze exams digitally.',
        razorpay_key_id: r.data.razorpay_key_id||'',
        razorpay_key_secret: r.data.razorpay_key_secret||'',
        gemini_api_key: r.data.gemini_api_key||'',
        gemini_model: r.data.gemini_model||'gemini-3.6-flash',
        blocked_junk_names: parseList(r.data.blocked_junk_names),
        blocked_profanity_words: parseList(r.data.blocked_profanity_words),
      });
      setCurrentQr(r.data.upi_qr||'');
    });
    API.get('/admin/banners').then(r => setBanners(r.data));
  }, []);

  const set = (key, val) => setForm(f => ({ ...f, [key]: val }));

  const saveSettings = async e => {
    e.preventDefault(); setSaving(true);
    try {
      const fd = new FormData();
      Object.entries(form).forEach(([k, v]) => fd.append(k, v));
      if (logo) fd.append('logo', logo);
      if (upiQr) fd.append('upi_qr', upiQr);
      await API.post('/admin/settings', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      toast.success('✅ Settings saved!');
      loadSettings();
    } catch { toast.error('Failed to save'); }
    finally { setSaving(false); }
  };

  const uploadBanner = async () => {
    if (!banner) return toast.error('Select a banner image');
    const fd = new FormData();
    fd.append('image', banner);
    fd.append('link_url', bannerLink);
    await API.post('/admin/banners', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
    toast.success('Banner uploaded!');
    setBanner(null); setBannerLink('');
    API.get('/admin/banners').then(r => setBanners(r.data));
  };

  const deleteBanner = async id => {
    await API.delete(`/admin/banners/${id}`);
    setBanners(b => b.filter(x => x.id !== id));
    toast.success('Removed');
  };

  const fg = { marginBottom: 16 };
  const lbl = { display:'block', fontSize:13, fontWeight:600, color:'var(--text2)', marginBottom:6 };
  const inp = { width:'100%', background:'var(--bg)', border:'1px solid var(--border)', borderRadius:8, padding:'10px 14px', color:'var(--text)', fontSize:14, outline:'none', boxSizing:'border-box', fontFamily:'inherit' };

  return (
    <div>
      <Navbar />
      <div style={{ maxWidth:800, margin:'0 auto', padding:'32px 20px' }}>
        <div className="page-header"><h1>⚙️ Platform Settings</h1><p>Branding, payment, contact & banners</p></div>

        <form onSubmit={saveSettings}>
          {/* Branding */}
          <div className="card" style={{ marginBottom:24 }}>
            <h3 style={{ fontWeight:700, marginBottom:20 }}>🎨 Branding</h3>
            <div style={fg}><label style={lbl}>Brand Name</label><input style={inp} value={form.brand_name} onChange={e => set('brand_name', e.target.value)} placeholder="Oexams" /></div>
            <div style={fg}><label style={lbl}>Tagline</label><input style={inp} value={form.tagline} onChange={e => set('tagline', e.target.value)} placeholder="Smart Exams for Smart Teachers" /></div>
            <div style={fg}>
              <label style={lbl}>Logo (shown on login page & header)</label>
              <input type="file" accept="image/*" onChange={e => setLogo(e.target.files[0])} style={{ padding:8 }} />
              <p style={{ fontSize:11, color:'var(--text3)', marginTop:4 }}>Wide banner format recommended (e.g. 400×80px)</p>
            </div>
          </div>

          {/* Payment Settings */}
          <div className="card" style={{ marginBottom:24 }}>
            <h3 style={{ fontWeight:700, marginBottom:8 }}>💳 Payment Settings</h3>
            <p style={{ color:'var(--text2)', fontSize:13, marginBottom:20 }}>Teachers will see these options when subscribing.</p>
            <div style={fg}><label style={lbl}>💸 UPI ID</label><input style={inp} value={form.upi_id} onChange={e => set('upi_id', e.target.value)} placeholder="yourname@upi" /></div>
            <div style={fg}>
              <label style={lbl}>📱 UPI QR Code Image</label>
              <input type="file" accept="image/*" onChange={e => setUpiQr(e.target.files[0])} style={{ padding:8 }} />
              {currentQr && <div style={{ marginTop:8 }}><img src={currentQr} alt="Current QR" style={{ height:120, borderRadius:8, border:'1px solid var(--border)' }} /><p style={{ fontSize:11, color:'var(--text3)', marginTop:4 }}>Current QR code</p></div>}
            </div>
            <div style={fg}><label style={lbl}>🔗 Payment Link</label><input style={inp} value={form.payment_link} onChange={e => set('payment_link', e.target.value)} placeholder="https://rzp.io/l/yourlink" /></div>
          </div>

          {/* ── CONTACT PAGE SETTINGS ── */}
          <div className="card" style={{ marginBottom:24, border:'1px solid rgba(99,102,241,0.35)' }}>
            <h3 style={{ fontWeight:700, marginBottom:4 }}>📬 Contact Page Settings</h3>
            <p style={{ color:'var(--text2)', fontSize:13, marginBottom:20 }}>These details appear on the public Contact Us page at <span style={{ color:'var(--primary-light)' }}>oexams.com/#/contact</span></p>

            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(260px,1fr))', gap:16, marginBottom:16 }}>
              <div><label style={lbl}>📧 Support Email</label><input style={inp} value={form.contact_email} onChange={e => set('contact_email', e.target.value)} placeholder="support@oexams.com" /></div>
              <div><label style={lbl}>📞 Phone Number</label><input style={inp} value={form.contact_phone} onChange={e => set('contact_phone', e.target.value)} placeholder="+91 XXXXX XXXXX" /></div>
              <div><label style={lbl}>💬 WhatsApp Number</label><input style={inp} value={form.contact_whatsapp} onChange={e => set('contact_whatsapp', e.target.value)} placeholder="+91 XXXXX XXXXX" /></div>
              <div><label style={lbl}>🕐 Support Hours</label><input style={inp} value={form.contact_hours} onChange={e => set('contact_hours', e.target.value)} placeholder="Mon–Sat, 9 AM – 6 PM IST" /></div>
              <div><label style={lbl}>📍 City / Location</label><input style={inp} value={form.contact_city} onChange={e => set('contact_city', e.target.value)} placeholder="New Delhi, India" /></div>
              <div><label style={lbl}>🏠 Full Address (optional)</label><input style={inp} value={form.contact_address} onChange={e => set('contact_address', e.target.value)} placeholder="123, Street, City, State - PIN" /></div>
            </div>

            <div><label style={lbl}>🏢 About Us Text (shown on Contact page)</label>
              <textarea style={{ ...inp, resize:'vertical' }} rows={3} value={form.contact_about} onChange={e => set('contact_about', e.target.value)} placeholder="Brief description of your platform..." />
            </div>
          </div>

          <div className="card" style={{ marginBottom:24, border:'1px solid rgba(16,185,129,0.35)' }}>
            <h3 style={{ fontWeight:700, marginBottom:4 }}>💳 Razorpay Settings</h3>
            <p style={{ color:'var(--text2)', fontSize:13, marginBottom:20 }}>Add your Razorpay API keys to enable instant online payments.</p>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(260px,1fr))', gap:16 }}>
              <div><label style={lbl}>🔑 Razorpay Key ID</label><input style={inp} value={form.razorpay_key_id} onChange={e => set('razorpay_key_id', e.target.value)} placeholder="rzp_live_XXXXXXXXXX" /></div>
              <div><label style={lbl}>🔒 Razorpay Key Secret</label><input style={{...inp, fontFamily:'monospace'}} type="password" value={form.razorpay_key_secret} onChange={e => set('razorpay_key_secret', e.target.value)} placeholder="Your secret key" /></div>
            </div>
            <p style={{ fontSize:11, color:'var(--text3)', marginTop:12 }}>Find these at: razorpay.com → Settings → API Keys</p>
          </div>

          <div className="card" style={{ marginBottom:24, border:'1px solid rgba(99,102,241,0.35)' }}>
            <h3 style={{ fontWeight:700, marginBottom:4 }}>🤖 AI Question Generation (Gemini)</h3>
            <p style={{ color:'var(--text2)', fontSize:13, marginBottom:20 }}>Powers teachers' "Generate from PDF" feature. Without a key set here, that feature is disabled platform-wide.</p>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(260px,1fr))', gap:16 }}>
              <div><label style={lbl}>🔒 Gemini API Key</label><input style={{...inp, fontFamily:'monospace'}} type="password" value={form.gemini_api_key} onChange={e => set('gemini_api_key', e.target.value)} placeholder="Your Gemini API key" /></div>
              <div><label style={lbl}>🧠 Gemini Model</label><input style={inp} value={form.gemini_model} onChange={e => set('gemini_model', e.target.value)} placeholder="gemini-3.6-flash" /></div>
            </div>
            <p style={{ fontSize:11, color:'var(--text3)', marginTop:12 }}>Get a key at: aistudio.google.com/apikey</p>
          </div>

          <div className="card" style={{ marginBottom:24, border:'1px solid rgba(239,68,68,0.35)' }}>
            <h3 style={{ fontWeight:700, marginBottom:4 }}>🚫 Student Name Filter</h3>
            <p style={{ color:'var(--text2)', fontSize:13, marginBottom:20 }}>Blocks inappropriate or obviously-fake names when a student registers for an exam. One entry per line (or comma-separated). Changes apply immediately — no code deploy needed.</p>
            <div style={fg}>
              <label style={lbl}>Junk / fake names (blocked only on exact match — e.g. "xyz", "test")</label>
              <textarea style={{ ...inp, resize:'vertical', fontFamily:'monospace' }} rows={5} value={form.blocked_junk_names} onChange={e => set('blocked_junk_names', e.target.value)} placeholder="xyz&#10;test&#10;fake&#10;dummy" />
            </div>
            <div>
              <label style={lbl}>Profanity / inappropriate words (blocked if found anywhere inside the name)</label>
              <textarea style={{ ...inp, resize:'vertical', fontFamily:'monospace' }} rows={8} value={form.blocked_profanity_words} onChange={e => set('blocked_profanity_words', e.target.value)} placeholder="porn&#10;fuck&#10;khanki" />
              <p style={{ fontSize:11, color:'var(--text3)', marginTop:4 }}>Keep these words reasonably long/specific — very short words can accidentally match inside real names.</p>
            </div>
          </div>

          <button type="submit" className="btn btn-primary btn-lg" style={{ width:'100%' }} disabled={saving}>
            {saving ? '⏳ Saving...' : '💾 Save All Settings'}
          </button>
        </form>

        {/* Banners */}
        <div className="card" style={{ marginTop:24 }}>
          <h3 style={{ fontWeight:700, marginBottom:8 }}>📢 Advertisement Banners</h3>
          <p style={{ color:'var(--text2)', fontSize:13, marginBottom:16 }}>Shown at top of every user's screen. Optional tap link.</p>
          <div style={fg}><label style={lbl}>Banner Image</label><input type="file" accept="image/*" onChange={e => setBanner(e.target.files[0])} style={{ padding:8 }} /></div>
          <div style={fg}><label style={lbl}>Tap Link (optional)</label><input style={inp} value={bannerLink} onChange={e => setBannerLink(e.target.value)} placeholder="https://example.com" /></div>
          <button className="btn btn-primary" onClick={uploadBanner}>📤 Upload Banner</button>
          {banners.length > 0 && (
            <div style={{ marginTop:20 }}>
              <h4 style={{ marginBottom:12, color:'var(--text2)' }}>Active Banners</h4>
              {banners.map(b => (
                <div key={b.id} style={{ display:'flex', alignItems:'center', gap:12, background:'var(--card2)', padding:10, borderRadius:10, marginBottom:8 }}>
                  <img src={b.image_path} alt="banner" style={{ height:44, borderRadius:6, objectFit:'cover' }} />
                  <div style={{ flex:1, fontSize:13, color:'var(--text2)' }}>{b.link_url || 'No link'}</div>
                  <button className="btn btn-danger btn-sm" onClick={() => deleteBanner(b.id)}>🗑️</button>
                </div>
              ))}
            </div>
          )}
        </div>

      </div>
    </div>
  );
}
